import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [posts, setPosts] = useState([]);
  const { lang } = useLang();
  const preview = new URLSearchParams(window.location.search).get("preview") === "draft";

  useEffect(() => {
    const req = preview
      ? api.get("/content/draft").catch(() => api.get("/content"))
      : api.get("/content");
    Promise.resolve(req).then((r) => setContent(r.data)).catch(() => setContent(undefined));
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => setPosts([]));
  }, []); // eslint-disable-line

  const L = (field) =>
    field && typeof field === "object" && !Array.isArray(field)
      ? field[lang] ?? field.EN ?? ""
      : field ?? "";

  useEffect(() => {
    const b = content?.brand;
    if (!b) return;
    if (b.favicon) {
      const link = document.querySelector("link[rel='icon']");
      if (link) link.href = b.favicon;
    }
    const root = document.documentElement.style;
    if (b.color_accent) root.setProperty("--gold", b.color_accent);
    if (b.color_primary) root.setProperty("--navy", b.color_primary);
    if (b.color_secondary) root.setProperty("--cream", b.color_secondary);
  }, [content]);

  return <ContentContext.Provider value={{ content, posts, L, preview }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
